import { SortOption } from '../types';

export enum TaskGroups {
  None = 'none',
  Day = 'day',
  Month = 'month',
  Year = 'year',
  Status = 'status',
  Type = 'type',
}

export const taskGroups: Record<string, string> = {
  none: 'none',
  day: 'day',
  month: 'month',
  year: 'year',
  status: 'status',
  type: 'type',
} as const;

export type SortingTask = [SortFields, SortDirection];

export enum SortFields {
  Date = 'date',
  Status = 'status',
  Name = 'name',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export const groupDataSettings = {
  [TaskGroups.Day]: 10,
  [TaskGroups.Month]: 7,
  [TaskGroups.Year]: 4,
} as const;

export const taskGroupOptions: { value: TaskGroups; label: string }[] = [
  { value: TaskGroups.None, label: 'Без группировки' },
  { value: TaskGroups.Day, label: 'По дате (дням)' },
  { value: TaskGroups.Month, label: 'По дате (месяцам)' },
  { value: TaskGroups.Year, label: 'По дате (годам)' },
  { value: TaskGroups.Status, label: 'По статусу' },
  { value: TaskGroups.Type, label: 'По типу' },
];

export const sortDirectionLabels = {
  [SortDirection.Desc]: 'по убыванию',
  [SortDirection.Asc]: 'по возрастанию',
} as const;

export const sortFieldLabels = {
  [SortFields.Date]: 'По дате',
  [SortFields.Status]: 'По статусу',
  [SortFields.Name]: 'По названию',
} as const;

export const sortSettings: SortingTask[] = [
  [SortFields.Date, SortDirection.Desc],
  [SortFields.Date, SortDirection.Asc],
  [SortFields.Status, SortDirection.Desc],
  [SortFields.Status, SortDirection.Asc],
  [SortFields.Name, SortDirection.Desc],
  [SortFields.Name, SortDirection.Asc],
];

export const sortFieldOptions: SortOption[] = [];
sortSettings.forEach((values) => {
  sortFieldOptions.push({
    values,
    label: `${sortFieldLabels[values[0]]}, ${sortDirectionLabels[values[1]]}`,
    value: values.join(''),
  });
});
